// extracted by mini-css-extract-plugin
module.exports = {"selectedTitle":"UserGuide_selectedTitle__1nHhO","styledCol":"UserGuide_styledCol__kZhsP","allTitles":"UserGuide_allTitles__3sWUP","booksrow":"UserGuide_booksrow__3pmLC"};